import * as axios from "axios";
import { getAuthHeader, setStorage } from "../utils";
import constant from "../constant";

/*
 * CHECK EMAIL (forgot-password flow)
 * REQ: POST /v2/borrower/check-email
 * Body: { "email": "user@example.com" }
 * RES 200: { "result": { "exists": true, "registered": true }, "error": null }
 *          { "result": { "exists": true, "registered": false }, "error": null }  // not registered → show password, then register
 *          { "result": { "exists": false, "registered": false }, "error": null } // redirect login + toast
 */
export const checkEmail = (model: { email: string }) => {
  const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/check-email`;
  return axios
    .post(url, model)
    .then((res: any) => res.data)
    .catch((err: any) => {
      const data = err.response?.data;
      return Promise.resolve(
        data || { result: null, error: err.message || "Request failed" },
      );
    });
};

/*
 * CREATE ACCOUNT (register)
 * REQ: POST /v2/borrower/create-account (or register)
 * Body: { "email": "borrower@example.com", "newPassword": "thePasswordTheyWant", "confirmPassword": "thePasswordTheyWant" }
 * RES 200: { "result": { ... }, "error": null }
 */
export const register = (model: {
  email: string;
  newPassword: string;
  confirmPassword: string;
}) => {
  const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/create-account`;
  return axios
    .post(url, model)
    .then((res: any) => res.data)
    .catch((err: any) => {
      const data = err.response?.data;
      return Promise.resolve(
        data || { result: null, error: err.message || "Request failed" },
      );
    });
};

export const login = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/login`;
  return axios.post(url, model).then((res: any) => {
    if (res.data.result) {
      setStorage(constant.key.token, res.data.result.token);
      setStorage(constant.key.userDetail, res.data.result);
    }
    return res.data;
  });
};

export const changePassword = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/change-password`;
  return axios.post(url, model, getAuthHeader()).then((res: any) => {
    return res.data;
  });
};

export const forgotPassword = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/forgot-password`;
  return axios.post(url, model, getAuthHeader()).then((res: any) => {
    return res.data;
  });
};

export const resetPassword = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/reset-password`;
  return axios.post(url, model, getAuthHeader()).then((res: any) => {
    return res.data;
  });
};

export const registerOld = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/register`;
  return axios.post(url, model, getAuthHeader()).then((res: any) => {
    return res.data;
  });
};
